import axios from "axios";

const getDefaultState = () => {
  return {
    step: 1,
    informar_placa: true,
    placa: "",
    veiculo: {
      carregando: false,
      msgErro: "",
      dados: null,
    },
    pedidosLiberados: {
      carregando: false,
      msgErro: "",
      dados: [],
    },
    pedidosAdicionados: [],
  };
};

const formacaoCargaStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setInformarPlaca(state, value) {
      state.informar_placa = value;
    },
    setPlaca(state, value) {
      state.placa = value;
    },
    setVeiculo(state, value) {
      state.veiculo.dados = value;
    },
    nextStep(state) {
      state.step++;
    },
    backStep(state) {
      state.step--;
    },
    setPedidosLiberados(state, value) {
      state.pedidosLiberados.dados = value;
    },
    adicionarPedido(state, pedido) {
      state.pedidosAdicionados.push({...pedido});
    },
  },
  actions: {
    async buscarVeiculo(context) {
      context.commit("setVeiculo", null);
      context.state.veiculo.carregando = true;
      context.state.veiculo.msgErro = "";
      try {
        await axios
          .get("/nutricao-animal/formacao-carga/veiculo", {
            params: {
              placa: context.state.placa,
            },
          })
          .then((res) => {
            if (res.data.success) {
              context.commit("setVeiculo", res.data.data);
            } else {
              context.state.veiculo.msgErro = res.data.msg;
            }
          });
      } catch (error) {
        context.state.veiculo.msgErro = error;
      } finally {
        context.state.veiculo.carregando = false;
      }
    },
    async buscarPedidosLiberados(context) {
      context.commit("setPedidosLiberados", []);
      context.state.pedidosLiberados.carregando = true;
      context.state.pedidosLiberados.msgErro = "";
      try {
        await axios
          .get("/nutricao-animal/formacao-carga/pedidos")
          .then((res) => {
            if (res.data.success) {
              context.commit("setPedidosLiberados", res.data.data);
            } else {
              context.state.pedidosLiberados.msgErro = res.data.msg;
            }
          })
          .catch((error) => {
            context.state.pedidosLiberados.msgErro = error;
          });
      } catch (error) {
        context.state.pedidosLiberados.msgErro = error;
      } finally {
        context.state.pedidosLiberados.carregando = false;
      }
    },
  },
  getters: {
    pedidosDisponiveisSelecao(state) {
      return state.pedidosLiberados.dados.filter(
        (ped) => state.pedidosAdicionados.findIndex((pa) => pa.id_pedido == ped.id_pedido) < 0
      );
    },
  },
};

export default formacaoCargaStore;
